export const iconFontAwesomeTransportationShuttleSpace = (
	<i className="fa-solid fa-shuttle-space"></i>
);
